import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { tesaBlue, tesaBlue4 } from "../../styles/colors";

const useUploadDialogStyles = makeStyles((theme: Theme) =>
  createStyles({
    alignRight: {
      float: "right",
    },
    header: {
      marginBottom: theme.spacing(3),
      maxWidth: "94%",
      textTransform: "uppercase",
    },
    description: {
      marginBottom: theme.spacing(2),
    },
    textField: {
      "& > *": {
        width: "100%",
      },
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    MuiDropzoneArea: {
      "& .MuiDropzoneArea-root": {
        minHeight: 200,
        borderWidth: "2px",
        strokeDasharray: "4 6",
        borderRadius: 0,
        outlineColor: tesaBlue,

        "&.MuiDropzoneArea-active": {
          animation: "none",
          backgroundColor: tesaBlue4,
          backgroundImage: "none",
          borderColor: tesaBlue,
        },

        "& .MuiDropzoneArea-text": {
          fontSize: "16px",
          position: "absolute",
          top: "40%",
          left: "50%",
          transform: "translate(-50%, 0)",
        },

        "& .MuiDropzoneArea-icon": {
          position: "absolute",
          width: "40px",
          height: "40px",
          top: "40%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        },

        "& .MuiDropzonePreviewList-root": {
          paddingLeft: 12,
          position: "absolute",
          bottom: "6%",
        },
      },
    },
  }),
);

export default useUploadDialogStyles;
